import {RulesLogic} from 'json-logic-js';
import {isObject} from 'lodash';

type ExtractVarNames = (logic: RulesLogic, path?: string) => string[]

export const extractVarNames: ExtractVarNames = (jsonLogic, varPath = '') => {
  const allNames: ExtractVarNames = (logic, path = '') => {
    if (!isObject(logic)) return []

    if (Array.isArray(logic)) {
      return logic.flatMap(el => allNames(el, path));
    }

    if (Object.prototype.hasOwnProperty.call(logic, 'var')) {
      const name = logic['var'];
      if (name.startsWith('form')) {
        return [name.replace('form.', '')];
      } else if (name.startsWith('local')) {
        return [name.replace('local', path)];
      } else {
        return [];
      }
    }

    return Object.values(logic).flatMap(el => allNames(el, path));
  }

  // make sure all names are unique
  return [...new Set(allNames(jsonLogic, varPath))]
}

export const replaceVarNames = (logic: RulesLogic, values: Record<string, any>, path = ''): RulesLogic => {
    if (!isObject(logic)) return logic

    if (Array.isArray(logic)) {
      // typescript doesn't like returning RulesLogic[] where RulesLogic is expected
      return logic.map(el => replaceVarNames(el, values, path)) as any;
    }

    if (Object.prototype.hasOwnProperty.call(logic, 'var')) {
      const name = logic['var'];
      if (name.startsWith('form') && Object.prototype.hasOwnProperty.call(values, name.replace('form.', ''))) {
        return values[name.replace('form.', '')];
      } else if (name.startsWith('local') && Object.prototype.hasOwnProperty.call(values, name.replace('local', path))) {
        return values[name.replace('local', path)];
      } else {
        return logic;
      }
    }

    return Object.entries(logic).reduce((newLogic, [key, value]) => {
      newLogic[key] = replaceVarNames(value, values, path);
      return newLogic;
    }, {} as RulesLogic)
}
